module.exports = __webpack_public_path__ + "img/expand-arrow-down-small.e8047b02.svg";